export default defineNuxtPlugin(async () => {
  const { region } = useRuntimeConfig().public

  if (region) {
    const registrations = await navigator.serviceWorker?.getRegistrations() || []

    // Removes any lingering service workers from other regions on the same top-level domain.
    // E.g. if we visit vans.com/en-us first and get the sw-nora.js worker,
    // and then navigate to vans.com/en-gb, we'd still see the sw-nora.js worker
    // until pre-caching gets completed and the new sw-emea.js worker get installed instead.
    // This way we avoid having the wrong cache from a different region in place while pre-caching is happening.
    registrations
      .filter(
        (registration) =>
          registration.active?.scriptURL
          && !registration.active.scriptURL.endsWith(`-${region}.js`)
      )
      .forEach((registration) => {
        registration.unregister()
      })
  }
})
